/**
 * Generic Onboarding Page (Mobile)
 *
 * Unified onboarding screen that dynamically renders the appropriate form
 * based on URL parameter. Replaces 6 individual onboarding pages.
 *
 * Route: /onboarding/:category
 * - category: profile | investableAssets | realEstateAssets | liabilities | income | expenses | assumptions
 */

import { Navigate } from "react-router-dom";
import { CelebrationScreen } from "../components/CelebrationScreen";
import { SettingsPageLayout } from "../components/SettingsPageLayout";
import { ONBOARDING_CATEGORIES } from "../hooks/useOnboardingNavigation";
import { useOnboardingPageLogic } from "./OnboardingPage.logic";

function OnboardingPageMobile() {
  const {
    isValidCategory,
    category,
    FormComponent,
    categoryLabel,
    profileComplete,
    missingFields,
    nav,
  } = useOnboardingPageLogic();

  // Show celebration overlay after completing onboarding
  if (nav.showCelebration) {
    return <CelebrationScreen />;
  }

  // Validate category parameter and redirect if invalid
  if (!isValidCategory) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <SettingsPageLayout
      title={categoryLabel}
      category={category}
      basePath="/onboarding"
      screens={ONBOARDING_CATEGORIES}
      wrapAround={false}
      onDone={nav.handleDone}
      showDone={nav.showDone}
      isLastScreen={nav.isLastScreen}
      canComplete={profileComplete && !nav.isTransitioning}
      missingFields={missingFields}
    >
      <FormComponent />
    </SettingsPageLayout>
  );
}

export default OnboardingPageMobile;
